// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"005348ca","162":"8f3c7d10","400":"54bdbb1c","716":"d73c8235"}[chunkId] + ".chunk.js";
};